<div class="container">
  <label (click)="onPatentClick($event)">Patented</label>
  <img
    [src]="_light ? 'assets/logos/app-logo-light.png' : 'assets/logos/app-logo.png'"
    alt="Sage Logo"
  />
</div>
